module.exports = __webpack_public_path__ + "img/23.d4c99b8e.png";